import React from 'react';
import {connect} from 'react-redux';
import {Permissioned} from 'react-permissions';
import Util from '../../util/util';


class ConnectedButton extends React.Component {

    render(){
        return <button {...this.props}></button>;
    }
}

export default connect(Util.defaultMapStateToProps)(Permissioned(ConnectedButton));


// WEBPACK FOOTER //
// ./src/components/common/connectedButton.js